/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * This class provides an aggregation of the properties of a state object for the 'ui-router' libray.
 */
class State {
    /**
     * Builds a state.
     *
     * @param {Object} data State properties.
     */
    constructor(data) {
        Object.assign(this, data);
    }

    static abstractComponentState(name, component, only) {
        return new State({
            name,
            component,
            abstract: true,
            data: {
                permissions: {
                    only
                }
            }
        });
    }

    static abstractUrlState(name, url, only) {
        return new State({
            name,
            url,
            abstract: true,
            data: {
                permissions: {
                    only
                }
            }
        });
    }

    static componentState(name, component, url, title, params, only) {
        return new State({
            name,
            component,
            url,
            title,
            params,
            data: {
                permissions: {
                    only
                }
            }
        });
    }

    static componentStateWithFilter(name, component, url, title, only) {
        return State.componentState(name, component, url, title, {filter: {}}, only);
    }

    static templateState(name, template, url, title, only) {
        return new State({
            name,
            template,
            url,
            title,
            data: {
                permissions: {
                    only
                }
            }
        });
    }
}

export { State };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/State.js